import { Injectable } from '@angular/core';
import { BaseStoreFacade } from '@city/data-access';
import { select, Store } from '@ngrx/store';
import { StatePersistenceService, StorageSyncType } from '@spartacus/core';
import { Observable } from 'rxjs';
import { CategoriesMenuActions } from './store/actions';
import { CATEGORIES_MENU_FEATURE, CategoriesMenuState, StateWithCategoriesMenu } from './store/categories-menu-state';
import { CategoriesMenuSelectors } from './store/selectors';

@Injectable({
  providedIn: 'root',
})
export class CategoriesMenuStatePersistenceService {
  constructor(
    protected statePersistenceService: StatePersistenceService,
    protected store: Store<StateWithCategoriesMenu>,
    private baseStores: BaseStoreFacade,
  ) {}

  public sync(): void {
    this.statePersistenceService.syncWithStorage({
      key: CATEGORIES_MENU_FEATURE,
      state$: this.getState(),
      context$: this.baseStores.getActiveCode(),
      storageType: StorageSyncType.SESSION_STORAGE,
      onRead: (state: CategoriesMenuState) => this.onRead(state),
    });
  }

  protected getState(): Observable<CategoriesMenuState> {
    return this.store.pipe(select(CategoriesMenuSelectors.getFeatureState));
  }

  protected onRead(state: CategoriesMenuState): void {
    if (state) {
      this.store.dispatch(new CategoriesMenuActions.CategoriesMenuSetState(state.categoriesMenu.value));
    }
  }
}
